export const rememberOpenCaptureDetailsRequest = (
  previousRequest = { key: '', requestKey: '' },
  navigationState = null,
  locationKey = ''
) => {
  const incomingKey = String(navigationState?.openCaptureDetailsKey || '').trim();
  if (!incomingKey) {
    return previousRequest;
  }

  return {
    key: incomingKey,
    requestKey: String(locationKey || incomingKey),
  };
};

export const consumeOpenCaptureDetailsRequest = (navigationState = null) => {
  const state = navigationState && typeof navigationState === 'object'
    ? navigationState
    : null;
  const captureDetailsKey = String(state?.openCaptureDetailsKey || '').trim();
  if (!captureDetailsKey) {
    return { captureDetailsKey: '', remainingState: state };
  }

  const remainingState = { ...state };
  delete remainingState.openCaptureDetailsKey;
  delete remainingState.openCaptureDetailsRequestKey;

  return {
    captureDetailsKey,
    remainingState: Object.keys(remainingState).length ? remainingState : null,
  };
};

export const consumeChildSelectionRequest = (
  navigationState = null,
  availableChildIds = []
) => {
  const state = navigationState && typeof navigationState === 'object'
    ? navigationState
    : null;

  if (state?.childShellTarget) {
    return {
      hadRequest: false,
      requestedChildId: '',
      remainingState: state,
    };
  }

  const requestedChildId = String(
    state?.childId || state?.selectedChildId || ''
  ).trim();
  if (!requestedChildId) {
    return {
      hadRequest: false,
      requestedChildId: '',
      remainingState: state,
    };
  }

  const remainingState = { ...state };
  delete remainingState.childId;
  delete remainingState.selectedChildId;

  return {
    hadRequest: true,
    requestedChildId: availableChildIds.includes(requestedChildId)
      ? requestedChildId
      : '',
    remainingState: Object.keys(remainingState).length ? remainingState : null,
  };
};
